import { render } from "./orderStatusModal.vue?vue&type=template&id=38b0f32c"
import script from "./orderStatusModal.vue?vue&type=script&lang=js"
export * from "./orderStatusModal.vue?vue&type=script&lang=js"

import "./orderStatusModal.vue?vue&type=style&index=0&id=38b0f32c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__